import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_365: DocMigration = {
  maxSchemaVersion: "0.0.365",
  description: "Correctly migrate parameters of LEVEL type to CONTENT_SOURCE type",
  apply(json: any) {
    for (const parameterId in json.parameters) {
      const parameter = json.parameters[parameterId];

      if (parameter.type === "LEVEL") {
        parameter.type = "CONTENT_SOURCE";
        parameter.viewType = "PLAN_VIEW";
      }
    }
    return json;
  },
};

export default migration_0_0_365;
